<template>
    <input type="file" name="file" class="form-control" @change="uploadPic($event)"/>
</template>
<script>
    export default {
        name: "EberUpload",
        props: ['index'],
        components: {},
        data() {
            return{
                isCollapse:true
            }
        },
        methods: {
            //上传图片
            uploadPic(e){
                let file = e.target.files[0]; //获取目标文件
                if(file){
                    this.handleBeforeUpload (file);
                }
                e.target.value='';
            },
            //上传图片（视频）是否正确
            handleBeforeUpload (file) {
                let type = file.type;
                if (!type) {
                    this.$message.error('文件:' + file.name + '的类型不正确')
                    return;
                }
                if (type.indexOf('image/') !== 0 && type.indexOf('video/') !== 0) {
                    this.$message.error('不支持文件:' + file.name + '的类型')
                    return;
                }
                this.uploadFile(file);
            },
            uploadFile (file) {
                let type =file.type
                if (type.indexOf('image/') === 0) {
                    this.$emit('changePic',0,file,this.index);
                }else{
                    this.$emit('changePic',1,file,this.index);
                }
            }
        }
    }
</script>